<template>
	<div class="content">
		<div class="row animated fadeIn">
			<div class="col-md-12">
				<Alert :type="alertType" :message="alertMessage" v-if="alertShow === true"/>
				<div class="card">
					<div class="card-header">
						<h4 class="card-title">Admins List</h4>
					</div>
					<div class="card-body">
						<UserList/>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "AdminList",
		components: {
			Alert: () =>
				import(/* webpackChunkName: "alert" */ "../../../components/Alerts.vue"),
			UserList: () =>
				import(/* webpackChunkName: "userList" */ "../../../components/Admin/EditUser/AdminList/AdminList.vue")
		},
		computed: {
			asyncDone() {
				return this.$store.getters["async/state"];
			},
			alertType() {
				return this.$store.getters["alert/type"];
			},
			alertMessage() {
				return this.$store.getters["alert/message"];
			},
			alertShow() {
				return this.$store.getters["alert/show"];
			},
			hasAllCustomer() {
				return this.$store.getters["customer/hasAllCustomers"]
			}
		}
	};
</script>
